import { GREEN, GREEN_TINT } from '../../../../components/choice-look'

// A chosen extra wears the booking screen's one chosen look, the wash
// cards' green (components/choice-look.js, DESIGN.md §10).

export const styles = () => ({
  root: { display: 'flex', flexDirection: 'column', gap: 8 },
  chips: { display: 'flex', flexWrap: 'wrap', gap: 8 },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 12px 8px 8px',
    borderRadius: 999,
    border: '1.5px solid #dbe2ea',
    background: '#fff',
    color: '#0f172a',
    fontFamily: 'inherit',
    fontSize: 14,
    lineHeight: 1.2,
    cursor: 'pointer',
    textAlign: 'left',
    // 44 tall on a phone (were 38; QA, 9 Oct 2026, DESIGN.md §3 --tap-min).
    minHeight: 44,
    '&:hover': { borderColor: '#94a3b8' }
  },
  chipOn: { borderColor: GREEN, background: GREEN_TINT },
  tick: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: '1.5px solid #cbd5e1',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    flexShrink: 0
  },
  tickOn: { background: GREEN, borderColor: GREEN },
  chipName: { fontWeight: 500 },
  chipPrice: { color: GREEN, fontWeight: 600, marginLeft: 2 },
  moreLink: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    padding: '4px 0',
    minHeight: 44,
    border: 0,
    background: 'none',
    color: '#0f766e',
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer'
  }
})
